import { useQuery } from '@tanstack/react-query';
import { getSignupClaim } from 'shared/services/backend-api';
import { getErrorReporter } from 'shared/services/error-tracking';

export const queryKey = 'get-signup-claim';

// The claim's server-side lifetime — refetching inside it cannot yield a different address.
const CLAIM_TTL_MS = 15 * 60 * 1000;

// Display-only, so a failure must not blank the page — a dead claim surfaces on submit instead.
export const resolveClaimEmailForDisplay = async (
  claimToken: string,
): Promise<string | null> => {
  try {
    return await getSignupClaim(claimToken);
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'get-signup-claim' },
    });

    return null;
  }
};

export const useSignupClaimQuery = (claimToken?: string) =>
  useQuery({
    queryKey: [queryKey, claimToken],
    queryFn: () =>
      claimToken ? resolveClaimEmailForDisplay(claimToken) : null,
    enabled: !!claimToken,
    staleTime: CLAIM_TTL_MS,
    gcTime: CLAIM_TTL_MS,
  });
